var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cleave',{class:_vm.classes,attrs:{"value":_vm.value,"options":_vm.opt,"placeholder":_vm.placeholder},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }